import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useMutation } from 'react-query';
import { userModel } from '../../../api';
import { Button, Dropdown, Heading, Input, Textarea } from '../../../UiKit';
import { Card } from '../../widgets/ReportIssue/Issues/common';

//  migrate from alert to react-hot-toast
function BlockUserModal(props) {
  const [inputValue, setInputValue] = React.useState('');
  const [reasonList, setReasonList] = useState({});
  const [reason, setReason] = useState();
  const [comment, setComment] = useState();

  const {
    mutate: getStatus,
    isLoading: isStatusLoading,
    isSuccess,
    data: userStatus,
  } = useMutation(userModel.userBlockStatus, {
    meta: {
      hideAlert: true,
    },
    onSuccess: (res) => {
      setReasonList(res.reasons);
    },
  });

  const { mutate: blockUser, isLoading: isBlocking } = useMutation(
    userModel.blockUser,
    {
      meta: {
        hideAlert: true,
      },
      onSuccess: (data) => {
        if (data.success) {
          toast.success(data.message);
          props.closePopup();
        }
      },
    },
  );
  const { mutate: unBlockUser, isLoading: isUnblocking } = useMutation(
    userModel.unBlockUser,
    {
      meta: {
        hideAlert: true,
      },
      onSuccess: (data) => {
        if (data.success) {
          toast.success(data.message);
        }
        props.closePopup();
      },
    },
  );

  const upadateUserStatus = (e) => {
    e.preventDefault();
    if (!reason) toast.error('Select an appropriate reason');
    else if (!comment) toast.error('Add some comment');
    else {
      const dataToSubmit = {
        user_id: inputValue,
        reason: reason,
        comment: comment,
      };
      userStatus.is_blocked
        ? unBlockUser(dataToSubmit)
        : blockUser(dataToSubmit);
    }
  };

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          getStatus(inputValue);
        }}
      >
        <Input
          showMaxLimit={false}
          required
          placeholder='Enter Customer Id'
          value={inputValue}
          onChange={(value) => setInputValue(value)}
        />
        <div
          css={`
            margin-bottom: 2rem;
          `}
        />
        {!userStatus && (
          <Button
            title='Submit'
            isDisabled={!inputValue}
            loading={isStatusLoading}
            outline={false}
            size='compressed'
          />
        )}
      </form>

      {isSuccess ? (
        <>
          <div>
            <Card
              content={{
                text: `Customer is ${
                  userStatus.is_blocked ? 'Blocked' : 'not Blocked'
                }`,
                bg_color: userStatus.is_blocked
                  ? 'rgb(255, 237, 239)'
                  : 'rgb(235, 255, 239)',
                border_color: userStatus.is_blocked ? 'red' : 'green',
                color: userStatus.is_blocked ? 'red' : 'green',
              }}
            />
          </div>
          <form onSubmit={upadateUserStatus}>
            <label
              htmlFor='reason'
              css={`
                margin: 1rem;
              `}
            >
              <Heading title='Reason' />
              <Dropdown
                dropDownValues={reasonList}
                onSelect={(value) => {
                  setReason(value);
                }}
                dropdownVal={reason}
                placeholder='Please Select a Reason'
              />
            </label>
            <label
              htmlFor='Comment'
              css={`
                margin-top: 2rem;
              `}
            >
              <Heading title='Comment' />
              <Textarea
                placeholder='Add some comment'
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                maxLimit='300'
                autoFocus={true}
                showBtn={false}
              />
            </label>
            <div
              css={`
                margin-top: 3rem;
              `}
            >
              <Button
                title='Submit'
                isDisabled={!inputValue}
                loading={isBlocking || isUnblocking}
                outline={false}
                size='small'
              />
            </div>
          </form>
        </>
      ) : null}
    </div>
  );
}

export { BlockUserModal };
